import styled from '@emotion/styled';
import { gettext } from '@eventbrite/i18n';
import { Divider, Typography } from '@eventbrite/marmalade';
import React from 'react';
import { useTransientAutoCreatedEventContext } from '../../../DraftEventStoreProvider';

export enum RefundPolicyContainerTestId {
    Container = 'RefundPolicyContainer',
}

export const RefundPolicy = () => {
    const { transientAutoCreatedEvent } = useTransientAutoCreatedEventContext();

    if (!transientAutoCreatedEvent) return null;
    return (
        <RefundPolicyContainer
            aria-label="Refund policy for this event"
            data-testid={RefundPolicyContainerTestId.Container}
        >
            <Typography as="p" color="neutral-900" variant="heading-sm">
                {gettext('Refund policy')}
            </Typography>
            <Typography as="p" color="neutral-900" variant="body-md">
                {gettext(
                    'Refunds are available up to 7 days before the event. The Eventbrite fee is non-refundable.',
                )}
            </Typography>
            <Divider />
        </RefundPolicyContainer>
    );
};

const RefundPolicyContainer = styled.section`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;
